<template>
    <!-- <div class="echarts" ref="echarts_info"></div> -->
    <div id="container" class="echarts complex-d3DIV"></div>
</template>

<script>
import forceJson  from './forceG6.json' 
import G6 from '@antv/g6'; 
export default {
    components: {},
    data() {
        return {
            graphWidth:'',
            graphHeight:'',
        }
    },
    watch: {},
    mounted() {  
        this.graph_init(); 
    },
    methods: {
        graph_init(){ 
            let container = document.getElementById('container');
            if (container) {
                this.graphWidth = container.clientWidth;
                this.graphHeight = container.clientHeight; 
                this.graph_tab('force',2);
            }
        },
           //图谱渲染
        graph_tab(val){  
            if (this.graph) this.graph.destroy();  
            this.graph = new G6.Graph({
                container: 'container',
                width:this.graphWidth,
                height:this.graphHeight, 
                modes: {
                    default: ['zoom-canvas','click-select','drag-canvas', 'drag-node','activate-relations','collapse-expand-combo'],
                },
                layout: {
                    type: 'force',
                    link: {
                    distance: (d) => {
                        if (d.source.id === 'node0') {
                        return 100;
                        }
                        return 30;
                    },
                    strength: (d) => {
                        if (d.source.id === 'node1' || d.source.id === 'node2' || d.source.id === 'node3') {
                        return 0.7;
                        }
                        return 0.1;
                    },
                    },
                },
                // layout: {
                //     type: 'force',  
                //     preventOverlap: true,
                //     linkDistance:220,
                // },  
                // animate: true,
                // //节点在默认状态下的样式属性
                defaultNode: { 
                    size:40,
                    // 节点文字
                    labelCfg: { 
                        position:this.labelPosition,
                        style:{
                            fontSize:14,
                            // stroke:'#000',
                            lineWidth: 2,
                            fill:'#000',
                        }
                    },
                },  
                nodeStateStyles: {
                    // 无关联的节点置灰
                    inactive: {
                        stroke: '#eee',
                        // lineWidth: 2,
                        opacity:.5,
                        'text-shape': {
                            fill: "#eee",
                            stroke: "#eee",
                        },
                    },
                },
                // 设置边高亮样式
                edgeStateStyles: {
                    highlight: {
                        // fill:'#A5E4F0',
                        // stroke: '#A5E4F0', // 这个颜色可以根据个人喜好进行修改
                        lineWidth:8,//lineWidth?lineWidth:4
                        opacity:1
                    },
                    inactive: {
                        stroke: '#eee',
                        fill: "#eee", 
                        'text-shape': {
                            opacity:0.01 
                        },
                    },
                },
                comboStateStyles: {
                    highlight: { 
                        opacity: 0.7,
                        cursor: "pointer",
                        'text-shape': { 
                            lineWidth: 4,
                        },
                    },
                    inactive: {
                        stroke: '#eee',
                        opacity:1,  
                        lineWidth: 4,
                        'text-shape': {
                            fill: "#eee",
                            stroke: "#eee",
                        },
                    },
                },

                //边在默认状态下的样式属性
                defaultEdge: {
                    labelCfg:{
                        style:{
                            opacity:0,
                            fontSize:16,
                            // fill:'#000',
                        }
                    },
                    style:{
                        opacity:.5, 
                        stroke:'#626161',//边的颜色
                        endArrow: { // 设置终点箭头
                            path: '', // 使用内置箭头路径函数，参数为箭头的 宽度、长度、偏移量（默认为 0，与 d 对应）
                            stroke:'#626161 ',
                            fill:'#626161 ', 
                        },
                    },
                    
                    // shape: 'arc',  // 在数据中已经指定 shape，这里无需再次指定
                    curveOffset: -80,
                },
            }); 
            let data= {
                nodes: [
                    { id: 'node0', size: 50 },
                    { id: 'node1', size: 30 },
                    { id: 'node2', size: 30 },
                    { id: 'node3', size: 30 },
                    { id: 'node4', size: 30, isLeaf: true },
                    { id: 'node5', size: 30, isLeaf: true },
                    { id: 'node6', size: 15, isLeaf: true },
                    { id: 'node7', size: 15, isLeaf: true },
                    { id: 'node8', size: 15, isLeaf: true },
                    { id: 'node9', size: 15, isLeaf: true },
                    { id: 'node10', size: 15, isLeaf: true },
                    { id: 'node11', size: 15, isLeaf: true },
                    { id: 'node12', size: 15, isLeaf: true },
                    { id: 'node13', size: 15, isLeaf: true },
                    { id: 'node14', size: 15, isLeaf: true },
                    { id: 'node15', size: 15, isLeaf: true },
                    { id: 'node16', size: 15, isLeaf: true },
                ],
                edges: [
                    { source: 'node0', target: 'node6' ,label:'1'},
                    { source: 'node1', target: 'node6' },
                    { source: 'node1', target: 'node7' },
                    { source: 'node6', target: 'node7' },

                    { source: 'node2', target: 'node8' },
                    { source: 'node2', target: 'node9' },
                    { source: 'node2', target: 'node10' },
                    { source: 'node2', target: 'node11' },
                    { source: 'node2', target: 'node12' },
                    { source: 'node9', target: 'node8' },
                    { source: 'node8', target: 'node10' },
                    { source: 'node9', target: 'node12' },
                    { source: 'node11', target: 'node10' },


                    { source: 'node2', target: 'node13' },
                    { source: 'node3', target: 'node14' },
                    { source: 'node3', target: 'node15' },
                    { source: 'node3', target: 'node16' },
                ],
            }; 
            this.graph.data(data);
            this.graph.render(); 
            //边的移入移出
            this.graph.on("edge:mouseenter", (e) => {  
                this.graph.setItemState(e.item, "highlight", true);
                this.edgesOpacity(e.item,1,'hover' )   
            });
            this.graph.on("edge:mouseleave", (e) => { 
                this.graph.setItemState(e.item, "highlight", false);
                this.edgesOpacity(e.item,0 ) 
                
            });  
            this.graph.on('node:mouseenter', this.graph_mouseenter)
            this.graph.on('node:mouseleave', this.graph_mouseleave) 
        },
        graph_mouseenter(e){
            let that = this // 改变this指向
            let item = e.item; 
            // 设置是否在更新/删除后自动重绘，一般搭配 paint() 方法使用。
            that.graph.setAutoPaint(false) 
            that.graph.getEdges().forEach(function (edge) { 
                //全部边文字显示
                that.edgesOpacity(edge,1 ,'hover' )    
                //getSource()获取当前边的起始节点。 getTarget获取当前边的终止节点。
                if (edge.getSource() != item && edge.getTarget() != item) {
                    that.edgesOpacity(edge,0,'hover')
                } 
            })
            that.graph.paint()
            that.graph.setAutoPaint(true)
        },
        //清除节点连线高亮状态
        graph_mouseleave () {
            const that = this
            this.graph.setAutoPaint(false)
            //边文字不显示
            this.graph.getEdges().forEach(function (edge) { 

                that.edgesOpacity(edge,0,)
            })
 
            this.graph.paint()
            this.graph.setAutoPaint(true)
        },
        //边laberl的文字透明度
        edgesOpacity(edge,num,type){
            let opacity = num;   
            if(this.sideLabel=='show'){
                opacity=0.5;
                if(type=='hover'){
                    opacity=1
                }
            }else{
                opacity=num;
            }
            this.graph.updateItem(edge, {
                labelCfg: {
                    style: {  
                        opacity,
                    }, 
                }
            }) 
        },
    }
}
</script>
<style lang='less' scoped>
.echarts{
    width: 1000px;
    margin: 40px auto;
    height: 600px;
    border:1px solid #333
}
</style>